<ng-container *vsLet="claim$ | async as claim">
  <vs-dialog
    *vsLet="item$ | async as item"
    #claimItemDetails
    [config]="{
      startOpen: item ? true : false,
      dialogContainerClass: 'w-[584px] max-w-[680px]'
    }"
    (closed)="!removing && item && navigateTo()"
  >
    <!-- header -->
    <vs-dialog-header
      [config]="{
        mode: 'simple',
        showDivider: true,

        icon: 'file-plus-03',
        iconTheme: 'primary',
        
        title: item ? 'Update Claim Item' : 'Add a Claim Item',
        subtitle: item ? 'Update the coverage for this claim item.' : 'Create items for each coverage needed to cover this claim.'
      }"
    >
    </vs-dialog-header>

    <form *vsLet="isCustomerPortal$ | async as isCustomerPortal" class="p-4" [formGroup]="form">
      <div class="flex flex-col gap-4">
        <p class="text-sm font-medium text-gray-500 -mb-2 mt-4">What is the issue related to?</p>

        <div class="flex flex-col gap-4 pb-4">
          <ws-coverage-picker [claim]="claim" formControlName="coverage"></ws-coverage-picker>

          <textarea
            *ngIf="form.value.coverage === null"
            vsInput
            min="3"
            max="6"
            formControlName="description"
            placeholder="Describe the issue in greater detail to help identify the coverage"
          ></textarea>
        </div>

        <ng-container *ngIf="!isCustomerPortal">
          <ws-claim-link-picker
            *vsLet="links$ | async"
            [claim]="claim"
            [id]="item?.id ?? null"
            formControlName="links"
          ></ws-claim-link-picker>
        </ng-container>

        <!-- shown only to Headstart (HWG) tenant-->
        <ng-container *ngIf="tenantId === 'tnt_b490a7f051ab4cd8a6695b3c036ebcad'">
          <!-- Date of purchase/install -->
          <div class="flex flex-col gap-3 flex-grow">
            <label class="text-sm font-medium text-gray-500">Date of Purchase/Install</label>
            <ng-container *ngIf="showPicker">
              <vs-input-container>
                <input
                  #dateInput
                  formControlName="dateOfPurchase"
                  class="picker-indicator-hidden"
                  type="date"
                  placeholder="Select a date of purchase/install"
                />
                <button
                  vs-icon-button
                  size="xs"
                  appearance="clear"
                  slot="end"
                  [vsMenuTriggerFor]="dateMenu"
                  #trigger="vsMenuTriggerFor"
                >
                  <vs-icon vsTooltip="Open date picker" name="calendar" size="16"></vs-icon>
                </button>
              </vs-input-container>
              <ng-template #dateMenu>
                <vs-menu>
                  <vs-date-picker
                    vs-menu-item
                    [value]="selectedDate"
                    (selectionChanged)="populateDate($any($event), trigger);"
                    [maxDate]="today"
                    [range]="false"
                  ></vs-date-picker>
                </vs-menu>
              </ng-template>
            </ng-container>
          </div>
        </ng-container>

        <!-- Buttons -->
        <div
          class="flex gap-2"
          [class.justify-end]="isCustomerPortal || !item"
          [class.justify-between]="!isCustomerPortal && item"
        >
          <ng-container *ngIf="!isCustomerPortal && item && item.status === draft">
            <button vs-button size="md" theme="danger" appearance="outline" (click)="openRemoveDialog()">Remove</button>
          </ng-container>

          <div class="flex gap-2">
            <button vs-button size="md" appearance="outline" (click)="item ? navigateTo() : closeDialog()">
              Cancel
            </button>

            <button
              [disabled]="tenantId === 'tnt_b490a7f051ab4cd8a6695b3c036ebcad' ? !form.controls.dateOfPurchase.valid : false"
              vs-button
              size="md"
              theme="primary"
              [disabled]="form.value.coverage === undefined || (form.value.coverage === null && !form.value.description)"
              (click)="save(claim)"
            >
              {{ item ? 'Update' : 'Save' }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </vs-dialog>
  <ws-claim-item-remove-dialog
    #removeDialog
    [claim]="claim"
    [item]="item"
    (removed)="closeRemoveDialog($event)"
  ></ws-claim-item-remove-dialog>
</ng-container>
